import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight, Lock, Sparkles } from "lucide-react";

export default function UpgradeRequiredPage({
  title = "Upgrade required",
  description = "Your current plan does not include access to this feature.",
}) {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-[100dvh] flex items-center justify-center overflow-hidden px-5 py-24 bg-[#edf2f7] dark:bg-[#0b1220]">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_10%_10%,rgba(16,185,129,0.16),transparent_42%),radial-gradient(circle_at_90%_18%,rgba(59,130,246,0.14),transparent_38%),radial-gradient(circle_at_45%_100%,rgba(14,165,233,0.12),transparent_45%)]" />
      <div className="absolute -top-20 -left-16 h-72 w-72 rounded-full bg-emerald-400/20 blur-3xl" />
      <div className="absolute -bottom-20 -right-16 h-80 w-80 rounded-full bg-cyan-400/20 blur-3xl" />

      <div className="relative w-full max-w-2xl rounded-3xl border border-white/70 dark:border-slate-700/80 bg-white/90 dark:bg-[#0f172a]/90 shadow-[0_35px_80px_rgba(15,23,42,0.22)] backdrop-blur-xl overflow-hidden">
        <div className="h-1.5 w-full bg-gradient-to-r from-emerald-400 via-green-500 to-cyan-400" />
        <div className="p-32">
          <div className="d-flex flex-center mb-20" style={{ gap: 12 }}>
            <span className="inline-flex items-center justify-center rounded-2xl p-12 bg-emerald-100/80 dark:bg-emerald-900/30 ring-1 ring-emerald-300/70 dark:ring-emerald-700/60">
              <Lock className="h-6 w-6 text-emerald-700 dark:text-emerald-300" />
            </span>
            <h2 className="text-2xl font-semibold tracking-tight text-slate-900 dark:text-white m-0">
              {title}
            </h2>
          </div>

          <p className="text-base text-slate-600 dark:text-slate-300 leading-relaxed mb-20">
            {description}
          </p>

          <div className="rounded-xl border border-emerald-200/90 dark:border-emerald-800/80 bg-gradient-to-r from-emerald-50 to-cyan-50 dark:from-emerald-950/30 dark:to-cyan-950/20 p-14 mb-24">
            <p className="m-0 text-sm sm:text-base text-emerald-800 dark:text-emerald-300 d-flex flex-center" style={{ gap: 8 }}>
              <Sparkles className="h-4 w-4" />
              Upgrade your plan to unlock this premium feature instantly.
            </p>
          </div>

          <div className="flex items-center justify-center">
            <button
              type="button"
              onClick={() => navigate("/account/upgrade")}
              className="group inline-flex items-center justify-center gap-2 rounded-xl border-0 bg-gradient-to-r from-emerald-600 to-green-600 px-6 py-3 text-sm font-semibold text-white cursor-pointer shadow-[0_12px_28px_rgba(16,185,129,0.35)] transition-all duration-200 hover:-translate-y-0.5 hover:from-emerald-500 hover:to-green-500 hover:shadow-[0_16px_34px_rgba(16,185,129,0.42)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-slate-900"
            >
              Upgrade Plan
              <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

